import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import * as tokens from '@trp-rps-rps-shared-web/rps-shared-web-styles';
import { Link, ConfidenceNumberGauge } from '@trp-rps-rps-shared-web/rps-shared-web-components';
import { modals } from '../../utils/constants';
import { modalActions } from '../../redux/root-action';
import { keyDown } from '../../utils/helpers';

const StyledContainer = styled.div`
  color: ${tokens.ColorWhite000};
  height: 118px;
  display: flex;
  flex-direction: column;
  padding-bottom: 10px;
  justify-content: flex-end;
  @media only screen and (max-width: 768px) {
    height: auto;
    align-items: center;
    justify-content: space-between;
    flex-direction: row;
    margin-top: 16px;
  }
`;

class ConfidenceNumberContainer extends Component<any> {
  showConfidenceNumberModal = () => {
    const { showModal } = this.props;
    showModal(modals.CONFIDENCE_NUMBER);
  };

  render(): JSX.Element {
    const mq = window.matchMedia('(max-width: 768px)');
    const { confidenceNumber } = this.props.simulationCurrentWant;
    return (
      <StyledContainer>
        {mq.matches && (
          <Link
            color="white"
            onClick={this.showConfidenceNumberModal}
            linkLabel="Confidence Number"
            registeredTradeMark={true}
            underline={true}
            tabIndex={0}
            onKeyPress={(e: React.KeyboardEvent<HTMLDivElement>) => keyDown(e, this.showConfidenceNumberModal)}
          />
        )}
        {confidenceNumber >= 0 && <ConfidenceNumberGauge confidenceNumber={Math.floor(confidenceNumber)} />}
        {!mq.matches && (
          <Link
            color="white"
            onClick={this.showConfidenceNumberModal}
            linkLabel="Confidence Number"
            registeredTradeMark={true}
            underline={true}
            customStyles={'position: relative'}
            tabIndex={0}
            onKeyPress={(e: React.KeyboardEvent<HTMLDivElement>) => keyDown(e, this.showConfidenceNumberModal)}
          />
        )}
      </StyledContainer>
    );
  }
}

const mapStateToProps = ({ charts }: any) => ({
  simulationCurrentWant: charts.simulationCurrentWant,
});

export default connect(mapStateToProps, {
  hideModal: modalActions.hideModal,
  showModal: modalActions.showModal,
})(ConfidenceNumberContainer);
